export enum IsImportedItemEnum{
    YES='YES',
    NO='NO',
}